export interface TagData {
  label: string
  bgColor: string
  textColor: string
}

/**
 * Get tag colors by index (cycles through 5 colors)
 * Uses the new Figma-based color scheme with proper Tailwind classes
 *
 * @param index - Index of the tag
 * @returns Object with bg and text color classes
 * 
 */
export function getTagColorsByIndex(index: number) {
  const tagColors = [
    { bg: 'rgba(100, 196, 255, 0.2)', text: '#64C4FF' }, // Blue
    { bg: 'rgba(20, 230, 189, 0.2)', text: '#14E6BD' }, // Teal
    { bg: 'rgba(192, 136, 255, 0.2)', text: '#C088FF' }, // Purple
    { bg: 'rgba(124, 227, 117, 0.2)', text: '#7CE375' }, // Green
    { bg: 'rgba(255, 153, 192, 0.2)', text: '#FF99C0' }, // Pink
  ]
  return tagColors[index % tagColors.length]
}


/**
 * Renders tag data with colors
 * Maps an array of tag strings to TagData objects with predefined colors
 *
 * @param tags - Array of tag strings
 * @returns Array of TagData objects with bgColor and textColor
 */
export function renderTagColor(tags: string[]): TagData[] {
  return tags.map((tag, index) => {
    const colors = getTagColorsByIndex(index)
    return {
      label: tag,
      bgColor: colors.bg,
      textColor: colors.text,
    }
  })
}
